import * as yupValidations from "./yupValidations";
import * as location from './loaction.validation';
import * as academicYear from './academicYear.validation';

const validations = {
  yupValidations,
  location,
  academicYear,
};

export default validations;
